import {
  useBlockProps,
  useInnerBlocksProps,
  InspectorControls,
} from '@wordpress/block-editor';
import { useSelect } from '@wordpress/data';

import EmptyImagePlaceholder from './EmptyImagePlaceholder';
import ContentPanel from './InspectorControls/ContentPanel';
import { MEDIA_GALLERY_ITEM_BLANK_TEMPLATE } from '../../_shared/media-gallery-item-defaults';

const ALLOWED_BLOCKS = [
  'core/image',
  'core/heading',
  'core/paragraph',
  'core/post-featured-image',
  'core/post-title',
  'core/post-excerpt',
];

// Blocks that count as "has an image already" for the EmptyImagePlaceholder
// gating logic — both the static (core/image) and dynamic (core/post-featured-image)
// flavours satisfy the requirement.
const IMAGE_BLOCK_NAMES = ['core/image', 'core/post-featured-image'];

export default function Edit({ context, clientId }) {
  const titlePosition = context?.['brandy/mediaGalleryTitlePosition'] ?? 'below';
  const isDynamic = !!context?.['brandy/mediaGalleryIsDynamic'];

  const hasImage = useSelect(
    (select) => {
      const inner = select('core/block-editor').getBlock(clientId)?.innerBlocks ?? [];
      return inner.some((b) => IMAGE_BLOCK_NAMES.includes(b.name));
    },
    [clientId]
  );

  const blockProps = useBlockProps({
    className: `brandy-media-gallery__item is-title-${titlePosition}`,
  });

  const innerBlocksProps = useInnerBlocksProps(
    { className: 'brandy-media-gallery__item-inner' },
    {
      // Static mode seeds three blocks (image + heading + paragraph). Dynamic
      // mode's inner-block tree is replaced by the parent's useEffect when
      // isDynamic flips, so this template only seeds static-mode insertions.
      template: MEDIA_GALLERY_ITEM_BLANK_TEMPLATE,
      allowedBlocks: ALLOWED_BLOCKS,
      templateLock: false,
      renderAppender: false,
    }
  );

  return (
    <>
      <InspectorControls>
        {/* ContentPanel only makes sense in static mode — dynamic-mode items
            use core/post-* blocks driven by the parent's WP_Query / filter. */}
        {!isDynamic && <ContentPanel clientId={clientId} />}
      </InspectorControls>
      <figure {...blockProps}>
        {hasImage || isDynamic ? (
          <div {...innerBlocksProps} />
        ) : (
          <EmptyImagePlaceholder clientId={clientId} />
        )}
      </figure>
    </>
  );
}
